import { type PropsWithChildren, memo } from 'react'

import HelpIcon from '../../assets/images/icons/help-icon.svg?react'
import { PositionMap } from '../../store/types/index'
import type { Product } from '../../store/types/product'

type Props = {
  product: Product
}

// TODO: change cell with actual table
function ProductCardIndexTable({ product }: Props): JSX.Element {
  return (
    <div className="text-xs text-gray-500 h-[148px]">
      <div className="grid grid-cols-4 border-gray-200 border md:rounded-t-lg overflow-hidden">
        <Cell isDark={true}>Index</Cell>
        <Cell isDark={true} className="col-span-2 text-center">
          Position
        </Cell>
        <Cell isDark={true}>Match</Cell>
        <Cell isDark={false}>{product.position?.myIndex}</Cell>
        <Cell isDark={false} className="col-span-2 text-center">
          {product.position?.myIsCheap > 0 ? (
            <div className="text-success-700 bg-success-50 rounded-2xl inline px-1 py-1 whitespace-nowrap">
              {PositionMap[product.position?.myIsCheap]}
            </div>
          ) : (
            '-'
          )}
        </Cell>
        <Cell isDark={false} className="whitespace-nowrap">
          {product.match_count} {product.match_count > 0 ? 'sites' : 'site'}
        </Cell>
      </div>
      <div className="grid grid-cols-4 border-gray-200 border md:rounded-b-lg overflow-hidden">
        <Cell isDark={true}>Min</Cell>
        <Cell isDark={true}>Max</Cell>
        <Cell isDark={true}>Avg</Cell>
        <Cell isDark={true} className="whitespace-nowrap">
          My Price
        </Cell>
        <Cell isDark={false}>{product.position?.minPrice?.value}</Cell>
        <Cell isDark={false}>{product.position?.maxPrice?.value}</Cell>
        <Cell isDark={false}>{product.position?.avgPrice?.value}</Cell>
        <Cell isDark={false}>{product.position?.myPrice}</Cell>
      </div>
    </div>
  )
}

const MemoProductCardIndexTable = memo(ProductCardIndexTable)

export default MemoProductCardIndexTable

function Cell({
  isDark = false,
  hasTooltip,
  tooltipText,
  children,
  className,
}: PropsWithChildren<{
  isDark: boolean
  hasTooltip?: boolean
  tooltipText?: string
  className?: string
}>): JSX.Element {
  return (
    <div
      className={`px-2 text-ellipsis ${
        isDark ? 'bg-gray-200 py-[10px] h-[36px]' : 'py-[11px] h-[38px]'
      } ${hasTooltip ? 'inline-flex gap-x-1' : 'overflow-hidden'}${className ? ` ${className}` : ''}`}
    >
      {children}
      {hasTooltip && (
        // <Tooltip text={`${tooltipText}`}>
        // <HelpIcon />
        // </Tooltip>
        <span className="group relative">
          <span className="pointer-events-none absolute -top-10 -left-3 -translate-x-1/2 whitespace-nowrap rounded bg-gray-900 px-2 py-1 text-white-100 opacity-0 transition before:absolute before:left-1/2 before:top-full before:-translate-x-1/2 before:border-4 before:border-transparent before:border-t-gray-900 before:content-[''] group-hover:opacity-100">
            {tooltipText}
          </span>
          <HelpIcon />
        </span>
      )}
    </div>
  )
}
